export const requestConsultantValidate = (consultantInfo) => {

    const errors = {}

    /*if (!consultantInfo.fullName.trim()) {
        errors.fullName = "لطفا نام و نام خانوادگی را وارد کنید"
    } else {
        delete errors.fullName
    }*/

    /*if (!consultantInfo.education.trim()) {
        errors.education = "لطفا تحصیلات را وارد کنید"
    } else {
        delete errors.education
    }*/

    /*if (consultantInfo.birthDate == "") {
        errors.birthDate = "لطفا تاریخ را وارد کنید"
    } else {
        delete errors.birthDate
    }*/

    /*if (!consultantInfo.phoneNumber.trim()) {
        errors.phoneNumber = "لطفا موبایل را وارد کنید"
    } else {
        delete errors.phoneNumber
    }*/

    // if (!consultantInfo.address.trim()) {
    //     errors.address = "لطفا آدرس را وارد کنید"
    // } else {
    //     delete errors.address
    // }

    // if (!consultantInfo.email.trim()) {
    //     errors.email = "لطفا ایمیل را وارد کنید"
    // } else {
    //     delete errors.email
    // }

    // if (!consultantInfo.aboutMe.trim()) {
    //     errors.aboutMe = "لطفا درباره من را وارد کنید"
    // } else {
    //     delete errors.aboutMe
    // }

    // if (consultantInfo.CV === undefined) {
    //     errors.CV = "لطفا رزومه را وارد کنید"
    // } else {
    //     delete errors.CV
    // }

    /*if (!consultantInfo.nationalID.trim()) {
        errors.nationalID = "لطفا کدملی را وارد کنید"
    } else {
        delete errors.nationalID
    }*/

    // if (!consultantInfo.landlinePhone.trim()) {
    //     errors.landlinePhone = "لطفا تلفن ثابت را وارد کنید"
    // } else {
    //     delete errors.landlinePhone
    // }

    return errors;
}